import { WebConfig, webConfigSchema } from '@quizdb/common';

/**
 * The app's runtime configuration (QZ-D10), loaded once by `main.tsx` before
 * anything else renders. `undefined` until `loadWebConfig` has resolved.
 */
let webConfig: WebConfig | undefined;

/**
 * Fetches `/config.json` and validates it against `webConfigSchema`. `cache:
 * 'no-store'` makes sure a deployed app always reads the config that was
 * written alongside it rather than a stale cached copy (QZ-D10).
 */
export const loadWebConfig = async (): Promise<WebConfig> => {
  const response = await fetch('/config.json', { cache: 'no-store' });
  const body = await response.json();
  webConfig = webConfigSchema.parse(body);
  return webConfig;
};

/** The loaded config. Throws if `loadWebConfig` has not resolved yet. */
export const getWebConfig = (): WebConfig => {
  if (!webConfig) {
    throw new Error('Web config has not been loaded yet');
  }
  return webConfig;
};
